import styled from "styled-components";
import { FlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const RecordSet = styled(FlexRow)`
  align-items: stretch;
  border-bottom: ${Theme.panelContentBorderStrong};

  &:last-child {
    border-bottom: 0;
  }
`;

export const SwissMatches = styled(FlexColumn)`
  flex-grow: 1;
`;

export const RecordContainer = styled.div`
  border-left: ${Theme.panelContentBorderStrong};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  min-width: 50px;
  font-weight: 500;
  @media (max-width: 1000px) {
    width: 100px;
  }

  @media (max-width: 1000px) {
    width: 70px;
  }

  @media (max-width: 700px) {
    width: 50px;
    font-size: 10pt;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;
